export default function useMasquerade() {
  const adminCookie = useAdminAccessTokenCookie()

  const isMasquerading = computed(() => Boolean(adminCookie.value))

  return {
    isMasquerading,
  }
}
